// @Version: 1.0.0
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, map, Observable, of } from 'rxjs';
import { LinkListPipe } from 'src/app/shared/pipes/link-list/link-list.pipe';
import { ILinkList } from 'src/app/shared/pipes/link-list/link-list.model';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';


@Injectable({
  providedIn: 'root'
})

export class SidenavNoLoginService {

   public TRANSLATE_PATH = TRANSLATE_PATH; 
   
   public depsNavShow: boolean = false; 
   public csvList: ILinkList[] = [];   
   public specialList: ILinkList[] = []; 
   
   

   constructor (public sTranslate: TranslateService, private pLinkList: LinkListPipe) { }

   public loadNav (): Observable<boolean> {

      return forkJoin([
         this.sTranslate.get(TRANSLATE_PATH.NAV_LIST_DEFAULT_LIST),
         //TODO: @project-specific Wenn eine special-nav vorhanden ist muss diese hier geladen werden
      ]).pipe(
         map(res => {
            this.depsNavShow = typeof res[0] != "string" && Object.keys(res[0]).length > 0;
            this.csvList = this.pLinkList.transform(res[0]);

            return true; 
         })
      )     
   }

   public resetNav (): Observable<boolean> {
      this.csvList = []; 
      this.specialList = [];

      return of(false); 
   }

   public resetSpecialNav (): void {
      this.specialList = []; 
   }
}